/**
 * https://github.com/Lissy93/currency-flags
 * The MIT License (MIT)
 * Copyright (c) Alicia Sykes <alicia@omg.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sub-license, and/or sell
 * copies of the Software, and to permit persons to whom the Software is furnished
 * to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included install
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANT ABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE AND NON INFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import { CurrencyCode } from "../../currencyCode";

export const currencyNames: {
  name: string;
  symbol: string;
  code: CurrencyCode;
}[] = [
  {
    name: "Arabic dirham",
    symbol: "د.إ",
    code: "AED",
  },
  {
    name: "Afghan afghani",
    symbol: "؋",
    code: "AFN",
  },
  {
    name: "Albanian lek",
    symbol: "Lek",
    code: "ALL",
  },
  {
    name: "Armenian dram",
    symbol: "֏",
    code: "AMD",
  },
  {
    name: "Netherlands Antillean guilder",
    symbol: "NAƒ",
    code: "ANG",
  },
  {
    name: "Angolan kwanza",
    symbol: "Kz",
    code: "AOA",
  },
  {
    name: "Argentine peso",
    symbol: "$",
    code: "ARS",
  },
  {
    name: "Australian dollar",
    symbol: "$",
    code: "AUD",
  },
  {
    name: "Aruban florin",
    symbol: "ƒ",
    code: "AWG",
  },
  {
    name: "Azerbaijani manat",
    symbol: "Əm",
    code: "AZN",
  },
  {
    name: "Barbadian dollar",
    symbol: "$",
    code: "BBD",
  },
  {
    name: "Bangladeshi taka",
    symbol: "৳",
    code: "BDT",
  },
  {
    name: "Bulgarian lev",
    symbol: "лв",
    code: "BGN",
  },
  {
    name: "Bahraini dinar",
    symbol: ".د.ب",
    code: "BHD",
  },
  {
    name: "Burundian franc",
    symbol: "Fr",
    code: "BIF",
  },
  {
    name: "Bermudian dollar",
    symbol: "$",
    code: "BMD",
  },
  {
    name: "Brunei dollar",
    symbol: "$",
    code: "BND",
  },
  {
    name: "Bolivian boliviano",
    symbol: "Bs.",
    code: "BOB",
  },
  {
    name: "Brazilian real",
    symbol: "R$",
    code: "BRL",
  },
  {
    name: "Bahamian dollar",
    symbol: "$",
    code: "BSD",
  },
  {
    name: "Bhutanese ngultrum",
    symbol: "Nu.",
    code: "BTN",
  },
  {
    name: "Botswana pula",
    symbol: "P",
    code: "BWP",
  },
  {
    name: "Belarusian ruble",
    symbol: "p.",
    code: "BYN",
  },
  {
    name: "Belize dollar",
    symbol: "$",
    code: "BZD",
  },
  {
    name: "Canadian dollar",
    symbol: "$",
    code: "CAD",
  },
  {
    name: "Congolese franc",
    symbol: "Fr",
    code: "CDF",
  },
  {
    name: "Swiss franc",
    symbol: "Fr",
    code: "CHF",
  },
  {
    name: "Chilean peso",
    symbol: "$",
    code: "CLP",
  },
  {
    name: "Chinese yuan",
    symbol: "¥",
    code: "CNY",
  },
  {
    name: "Colombian peso",
    symbol: "$",
    code: "COP",
  },
  {
    name: "Costa Rican colón",
    symbol: "₡",
    code: "CRC",
  },
  // {
  //   name: "Cuban peso",
  //   symbol: "$",
  //   code: "CUP",
  // },
  {
    name: "Cape Verdean escudo",
    symbol: "$",
    code: "CVE",
  },
  {
    name: "Czech koruna",
    symbol: "Kč",
    code: "CZK",
  },
  {
    name: "Djiboutian franc",
    symbol: "Fr",
    code: "DJF",
  },
  {
    name: "Danish krone",
    symbol: "kr",
    code: "DKK",
  },
  {
    name: "Dominican peso",
    symbol: "$",
    code: "DOP",
  },
  {
    name: "Algerian dinar",
    symbol: "د.ج",
    code: "DZD",
  },
  {
    name: "Egyptian pound",
    symbol: "£",
    code: "EGP",
  },
  {
    name: "Eritrean nakfa",
    symbol: "Nfk",
    code: "ERN",
  },
  {
    name: "Ethiopian birr",
    symbol: "Br",
    code: "ETB",
  },
  {
    name: "Euro",
    symbol: "€",
    code: "EUR",
  },
  {
    name: "Fijian dollar",
    symbol: "$",
    code: "FJD",
  },
  {
    name: "Falkland Islands pound",
    symbol: "£",
    code: "FKP",
  },
  {
    name: "Pound sterling",
    symbol: "£",
    code: "GBP",
  },
  {
    name: "Georgian lari",
    symbol: "₾",
    code: "GEL",
  },
  // {
  //   name: "Guernsey pound",
  //   symbol: "£",
  //   code: "GGP",
  // },
  {
    name: "Ghanaian cedi",
    symbol: "₵",
    code: "GHS",
  },
  {
    name: "Gibraltar pound",
    symbol: "£",
    code: "GIP",
  },
  {
    name: "Gambian dalasi",
    symbol: "D",
    code: "GMD",
  },
  {
    name: "Guinean franc",
    symbol: "Fr",
    code: "GNF",
  },
  {
    name: "Guatemalan quetzal",
    symbol: "Q",
    code: "GTQ",
  },
  {
    name: "Guyanese dollar",
    symbol: "$",
    code: "GYD",
  },
  {
    name: "Hong Kong dollar",
    symbol: "$",
    code: "HKD",
  },
  {
    name: "Honduran lempira",
    symbol: "L",
    code: "HNL",
  },
  {
    name: "Croatian kuna",
    symbol: "kn",
    code: "HRK",
  },
  {
    name: "Haitian gourde",
    symbol: "G",
    code: "HTG",
  },
  {
    name: "Hungarian forint",
    symbol: "Ft",
    code: "HUF",
  },
  {
    name: "Indonesian rupiah",
    symbol: "Rp",
    code: "IDR",
  },
  {
    name: "Israeli new shekel",
    symbol: "₪",
    code: "ILS",
  },
  // {
  //   name: "Manx pound",
  //   symbol: "£",
  //   code: "IMP",
  // },
  {
    name: "Indian rupee",
    symbol: "₹",
    code: "INR",
  },
  {
    name: "Iraqi dinar",
    symbol: "د.ع",
    code: "IQD",
  },
  {
    name: "Iranian rial",
    symbol: "﷼",
    code: "IRR",
  },
  {
    name: "Icelandic króna",
    symbol: "kr",
    code: "ISK",
  },
  {
    name: "Jersey pound",
    symbol: "£",
    code: "JEP",
  },
  {
    name: "Jamaican dollar",
    symbol: "$",
    code: "JMD",
  },
  {
    name: "Jordanian dinar",
    symbol: "د.ا",
    code: "JOD",
  },
  {
    name: "Japanese yen",
    symbol: "¥",
    code: "JPY",
  },
  {
    name: "Kenyan shilling",
    symbol: "KSh",
    code: "KES",
  },
  {
    name: "Kyrgyzstani som",
    symbol: "с",
    code: "KGS",
  },
  {
    name: "Cambodian riel",
    symbol: "៛",
    code: "KHR",
  },
  {
    name: "Comorian franc",
    symbol: "Fr",
    code: "KMF",
  },
  // {
  //   name: "North Korean won",
  //   symbol: "₩",
  //   code: "KPW",
  // },
  {
    name: "South Korean won",
    symbol: "₩",
    code: "KRW",
  },
  {
    name: "Kuwaiti dinar",
    symbol: "د.ك",
    code: "KWD",
  },
  {
    name: "Cayman Islands dollar",
    symbol: "$",
    code: "KYD",
  },
  {
    name: "Kazakhstani tenge",
    symbol: "₸",
    code: "KZT",
  },
  {
    name: "Lao kip",
    symbol: "₭",
    code: "LAK",
  },
  {
    name: "Lebanese pound",
    symbol: "ل.ل",
    code: "LBP",
  },
  {
    name: "Sri Lankan rupee",
    symbol: "රු",
    code: "LKR",
  },
  {
    name: "Liberian dollar",
    symbol: "$",
    code: "LRD",
  },
  {
    name: "Lesotho loti",
    symbol: "L",
    code: "LSL",
  },
  {
    name: "Libyan dinar",
    symbol: "ل.د",
    code: "LYD",
  },
  {
    name: "Moroccan dirham",
    symbol: "د.م.",
    code: "MAD",
  },
  {
    name: "Moldovan leu",
    symbol: "L",
    code: "MDL",
  },
  {
    name: "Malagasy ariary",
    symbol: "Ar",
    code: "MGA",
  },
  {
    name: "Macedonian denar",
    symbol: "ден",
    code: "MKD",
  },
  {
    name: "Myanmar kyat",
    symbol: "Ks",
    code: "MMK",
  },
  {
    name: "Mongolian tögrög",
    symbol: "₮",
    code: "MNT",
  },
  {
    name: "Macanese pataca",
    symbol: "MOP$",
    code: "MOP",
  },
  // {
  //   name: "Mauritanian ouguiya",
  //   symbol: "UM",
  //   code: "MRO",
  // },
  {
    name: "Mauritian rupee",
    symbol: "₨",
    code: "MUR",
  },
  {
    name: "Maldivian rufiyaa",
    symbol: ".ރ",
    code: "MVR",
  },
  {
    name: "Malawian kwacha",
    symbol: "MK",
    code: "MWK",
  },
  {
    name: "Mexican peso",
    symbol: "$",
    code: "MXN",
  },
  {
    name: "Malaysian ringgit",
    symbol: "RM",
    code: "MYR",
  },
  {
    name: "Mozambican metical",
    symbol: "MT",
    code: "MZN",
  },
  {
    name: "Namibian dollar",
    symbol: "$",
    code: "NAD",
  },
  {
    name: "Nigerian naira",
    symbol: "₦",
    code: "NGN",
  },
  {
    name: "Nicaraguan córdoba",
    symbol: "C$",
    code: "NIO",
  },
  {
    name: "Norwegian krone",
    symbol: "kr",
    code: "NOK",
  },
  {
    name: "Nepalese rupee",
    symbol: "रू",
    code: "NPR",
  },
  {
    name: "New Zealand dollar",
    symbol: "$",
    code: "NZD",
  },
  {
    name: "Omani rial",
    symbol: "ر.ع.",
    code: "OMR",
  },
  {
    name: "Panamanian balboa",
    symbol: "B/.",
    code: "PAB",
  },
  {
    name: "Peruvian nuevo sol",
    symbol: "S/.",
    code: "PEN",
  },
  {
    name: "Papua New Guinean kina",
    symbol: "K",
    code: "PGK",
  },
  {
    name: "Philippine peso",
    symbol: "₱",
    code: "PHP",
  },
  {
    name: "Pakistani rupee",
    symbol: "₨",
    code: "PKR",
  },
  {
    name: "Polish złoty",
    symbol: "zł",
    code: "PLN",
  },
  {
    name: "Paraguayan guaraní",
    symbol: "₲",
    code: "PYG",
  },
  {
    name: "Qatari riyal",
    symbol: "ر.ق",
    code: "QAR",
  },
  {
    name: "Romanian leu",
    symbol: "lei",
    code: "RON",
  },
  {
    name: "Serbian dinar",
    symbol: "din.",
    code: "RSD",
  },
  {
    name: "Russian ruble",
    symbol: "₽",
    code: "RUB",
  },
  {
    name: "Rwandan franc",
    symbol: "Fr",
    code: "RWF",
  },
  {
    name: "Saudi riyal",
    symbol: "ر.س",
    code: "SAR",
  },
  {
    name: "Solomon Islands dollar",
    symbol: "$",
    code: "SBD",
  },
  {
    name: "Seychellois rupee",
    symbol: "₨",
    code: "SCR",
  },
  {
    name: "Swedish krona",
    symbol: "kr",
    code: "SEK",
  },
  {
    name: "Singapore dollar",
    symbol: "$",
    code: "SGD",
  },
  {
    name: "Saint Helena pound",
    symbol: "£",
    code: "SHP",
  },
  {
    name: "Sierra Leonean leone",
    symbol: "Le",
    code: "SLL",
  },
  {
    name: "Somali shilling",
    symbol: "Sh",
    code: "SOS",
  },
  {
    name: "Surinamese dollar",
    symbol: "$",
    code: "SRD",
  },
  {
    name: "Syrian pound",
    symbol: "£",
    code: "SYP",
  },
  {
    name: "Thai baht",
    symbol: "฿",
    code: "THB",
  },
  {
    name: "Tajikistani somoni",
    symbol: "ЅМ",
    code: "TJS",
  },
  {
    name: "Turkmenistani manat",
    symbol: "m",
    code: "TMT",
  },
  {
    name: "Tunisian dinar",
    symbol: "د.ت",
    code: "TND",
  },
  {
    name: "Tongan paʻanga",
    symbol: "T$",
    code: "TOP",
  },
  {
    name: "Turkish lira",
    symbol: "₺",
    code: "TRY",
  },
  {
    name: "Trinidad and Tobago dollar",
    symbol: "$",
    code: "TTD",
  },
  {
    name: "New Taiwan dollar",
    symbol: "$",
    code: "TWD",
  },
  {
    name: "Tanzanian shilling",
    symbol: "Sh",
    code: "TZS",
  },
  {
    name: "Ukrainian hryvnia",
    symbol: "₴",
    code: "UAH",
  },
  {
    name: "Ugandan shilling",
    symbol: "Sh",
    code: "UGX",
  },
  {
    name: "United States dollar",
    symbol: "$",
    code: "USD",
  },
  {
    name: "Uruguayan peso",
    symbol: "$",
    code: "UYU",
  },
  {
    name: "Uzbekistani som",
    symbol: "Ўзб",
    code: "UZS",
  },
  {
    name: "Venezuelan bolívar",
    symbol: "Bs",
    code: "VEF",
  },
  {
    name: "Vietnamese đồng",
    symbol: "₫",
    code: "VND",
  },
  {
    name: "Vanuatu vatu",
    symbol: "Vt",
    code: "VUV",
  },
  {
    name: "Samoan tālā",
    symbol: "T",
    code: "WST",
  },
  {
    name: "Central African CFA franc",
    symbol: "Fr",
    code: "XAF",
  },
  {
    name: "East Caribbean dollar",
    symbol: "$",
    code: "XCD",
  },
  {
    name: "West African CFA franc",
    symbol: "Fr",
    code: "XOF",
  },
  {
    name: "CFP franc",
    symbol: "Fr",
    code: "XPF",
  },
  {
    name: "Yemeni rial",
    symbol: "﷼",
    code: "YER",
  },
  {
    name: "South African rand",
    symbol: "R",
    code: "ZAR",
  },
  {
    name: "Zambian kwacha",
    symbol: "ZK",
    code: "ZMW",
  },
];
